
import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import productOptionMixin from '@/mixin/productOption'
import currencyOptionMixin from '@/mixin/currencyOption'
import orderDateOptionMixin from '@/mixin/orderDateOption'
import { getDepositOrder, exportDepositOrder } from '@/api/merchant/order'
import pagination from '@/components/Pagination/index.vue'
import { Form as ElForm } from 'element-ui'
import { notifiedStatusList } from '@/utils/constant'
import { AppModule } from '@/store/modules/app'
import { delObjEmptyKey } from '@/utils'
import { getCurrentDate } from '@/utils/dateTime'

@Component({
  name: 'depositOrder',
  components: {
    pagination
  }
})
export default class extends mixins(
  productOptionMixin,
  currencyOptionMixin,
  orderDateOptionMixin
) {
  @Prop({ required: true }) merchant_no!: string

  queryForm: any = {
    status: null,
    notify_status: null,
    order_number: '',
    start_time: null,
    end_time: null,
    min_amount: '',
    max_amount: '',
    change_status_type: null,
    product_type: 'deposit'
  }
  private statusList: any[] = []
  private cbTypeList: any[] = []
  private orderList: any[] = []
  private listLoading: Boolean = false
  private totalData: any = {}
  private total = 0
  private listQuery = {
    page: 1,
    limit: 20
  }
  private notifiedStatusList = notifiedStatusList
  private orderStatusList: any[] = []
  private upstreamStatusList: any[] = []

  private tabName: string = 'Volume'
  private sendLoading: boolean = false

  private back () {
    this.$emit('close')
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange (size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange (currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi () {
    try {
      this.listLoading = true
      const data: any = {
        merchant_no: this.merchant_no,
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      await getDepositOrder(data).then((res: any) => {
        this.orderList = res.results
        this.total = res.count
        this.totalData = res.total_data
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private select () {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset () {
    this.queryForm = {
      currency: AppModule.currentCurrencyType,
      status: null,
      notify_status: null,
      order_number: '',
      start_time: null,
      end_time: null,
      notify_start_time: null,
      notify_end_time: null,
      product_code: '',
      product_account_no: '',
      min_amount: '',
      max_amount: '',
      change_status_type: null
    }
    this.date = getCurrentDate()
    this.notifyDate = []
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  // 获取订单列表
  private async getOrderList (isReset: boolean) {
    if (isReset) {
      this.listQuery.page = 1
    }
    this.listLoading = true
    const data: any = {
      merchant_no: this.merchant_no,
      ...this.queryForm,
      page: this.listQuery.page
    }
    delObjEmptyKey(data)
    try {
      await getDepositOrder(data).then((res: any) => {
        this.orderList = res.results
        this.total = res.count
        this.totalData = res.total_data
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private async exportData () {
    try {
      this.sendLoading = true
      const data: any = {
        ...this.queryForm,
        merchant_no: this.merchant_no
      }
      delObjEmptyKey(data)
      await exportDepositOrder(data).then(() => {
        this.$message({
          message: 'The form has been sent to your mailbox, please check it!',
          type: 'success'
        })
        this.sendLoading = false
      })
    } catch (e) {
      this.sendLoading = false
      this.$message({
        message: 'Export failure!',
        type: 'error'
      })
    }
  }

  async created () {
    this.orderStatusList = await AppModule.GetOrderStatusList()
    this.upstreamStatusList = await AppModule.GetUpstreamStatusList()
    await AppModule.GetConstant().then((res: any) => {
      this.statusList = res.IN_ORDER_STATUS_CHOICES
      this.cbTypeList = res.ORDER_CHANGE_STATUS_TYPE_CHOICES
    })
    // await this.getOrderList(true)
    await this.hadleGetFilesListApi()
  }
  mounted () {}
}
